var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.25H15L19.5 6.75V19.5C19.5 20.0967 19.2629 20.669 18.841 21.091C18.419 21.5129 17.8467 21.75 17.25 21.75H6.75C6.15326 21.75 5.58097 21.5129 5.15901 21.091C4.73705 20.669 4.5 20.0967 4.5 19.5V4.5C4.5 3.90326 4.73705 3.33097 5.15901 2.90901C5.58097 2.48705 6.15326 2.25 6.75 2.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25H8.25C7.42157 11.25 6.75 11.9216 6.75 12.75V18C6.75 18.8284 7.42157 19.5 8.25 19.5H15.75C16.5784 19.5 17.25 18.8284 17.25 18V12.75C17.25 11.9216 16.5784 11.25 15.75 11.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.125H10.5C10.0858 13.125 9.75 13.4608 9.75 13.875V16.875C9.75 17.2892 10.0858 17.625 10.5 17.625H13.5C13.9142 17.625 14.25 17.2892 14.25 16.875V13.875C14.25 13.4608 13.9142 13.125 13.5 13.125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15.375H9.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.375H17.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25V13.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25V13.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.625V19.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.625V19.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6948_30093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2586 5.10545C12.3367 5.02734 12.3367 4.90071 12.2586 4.8226L11.9775 4.54145C11.8994 4.46334 11.7727 4.46334 11.6946 4.54145L9.74147 6.4946C9.66337 6.57271 9.53673 6.57271 9.45863 6.4946L7.50547 4.54145C7.42737 4.46334 7.30073 4.46334 7.22263 4.54145L6.94147 4.8226C6.86337 4.90071 6.86337 5.02734 6.94147 5.10545L8.89463 7.0586C8.97273 7.13671 8.97273 7.26334 8.89463 7.34145L6.94147 9.2946C6.86337 9.37271 6.86337 9.49934 6.94147 9.57745L7.22263 9.8586C7.30073 9.93671 7.42737 9.93671 7.50547 9.8586L9.45863 7.90545C9.53673 7.82734 9.66337 7.82734 9.74147 7.90545L11.6946 9.8586C11.7727 9.93671 11.8994 9.93671 11.9775 9.8586L12.2586 9.57745C12.3367 9.49934 12.3367 9.37271 12.2586 9.2946L10.3055 7.34145C10.2274 7.26334 10.2274 7.13671 10.3055 7.0586L12.2586 5.10545Z",
    className: "sim-inactive-cross",
    fill: "#C54326",
    stroke: "#C54326",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6948_30093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    fill: "white",
    transform: "translate(4.80005 2.40002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimInactive);
export default __webpack_public_path__ + "static/media/SimInactive.ba2f288c.svg";
export { ForwardRef as ReactComponent };